import React, { useEffect } from "react";
import Navigation from "../Components/Navigation/Navigation";
import "../Pages/ProcessSales.css";
import Footer from "../Components/Navigation/Footer";
import LeaseExtensions from "../Documents/ZEN_Homes_Lease_Extension_Guide.pdf";
import PurchaseGuide from "../Documents/ZEN_Homes_Property_Purchase_Guide.pdf";
import Banner from "../Components/Banner";
import BrownBuilding from "../Assets/Images/Homepage/axp-photography.jpg";
import StackedImage from "../Assets/Images/Homepage/samuel-regan-asante.jpg";
import BannerBuilding from "../Assets/Images/Banner/process-sales.jpg"


function ProcessSales() {

   useEffect(() => {
      document.title = "Sales Process | Zen Homes";
    }, []);

  return (
    <div className="processRentContainer">
      <Navigation linkColor="black" submenuColor="black" menuIconColor="black"/>
      <Banner title="Process of Buying" backgroundImage={BannerBuilding} />
      <div className="processLayoutContainer">
        <div className="processInfo">
          <p>
          To make our process very smooth we have given you a step-by-step guide to the whole sale process and what we require.
          </p>
          <br />
          <ol>
            <li>Submitting an Offer – Once you place your offer (all offers must be submitted in writing and emailed over to us) we endeavor to speak to the seller immediately after negotiating and get your offer accepted. </li>
            <br />
            <li>Offer Acceptance – Once your offer is accepted, we require the following details below to process your offer
    
              <ul>
                <br />
                <li>Full Names/Company Name of the purchaser</li>
                <br />
                <li>Proof of Deposit – Bank statement showing funds in account</li>
                <br />
                <li>Proof of Mortgage – AIP/DIP in place from the bank</li>
                <br />
                <li>Mortgage Broker Details (only applicable if mortgage not obtained direct from the bank)</li>
                <br />
                <li>Solicitor/Conveyancing Details </li>
                <br />
              </ul>
            </li>
            <br />
            <li>Upon receiving all the details above, we will take the property off the market immediately, upload all details on our system and issue the Sale Memorandum to initiate the process. Then it will be in the hands of the lawyers for the legal proceedings to commence, which we shall chase from time to time and update you regularly on milestones in the transaction.</li>
          </ol>
          <p>
          Please see below links of the Purchase Guide & Lease Extension Guide (only applicable to short leasehold properties) 
          </p>
                  <div className="embedDocuments">
                  <a
                        href={PurchaseGuide}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          textDecoration: "underline",
                          color: "#177404",
                          fontSize: "20px",
                        }}
                      >
                        ZEN Homes Purchase Guide
                      </a>
                      <br />
                      <a
                        href={LeaseExtensions}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          textDecoration: "underline",
                          color: "#177404",
                          fontSize: "20px",
                        }}
                      >
                        ZEN Homes Lease Extension Guide
                      </a>
                      
                    </div>
        </div>
       <div className="stackedContainer">
                <img className="stackedOne" src={BrownBuilding} alt="AXP Photography" />
                <img className="stackedTwo" src={StackedImage} alt="Samuel Regan Asante.jpg" />
              </div>
      </div>
      <Footer />
    </div>
  );
}

export default ProcessSales;
